import React, { Component } from "react";
import TextBox from "./TextBox";
import CheckBox from "./CheckBox";
import RadioButton from "./RadioButton";
import DropDown from "./DropDown";
import './InitialFormStyleSheet.css';
import apiService from "../Services/APIService";

class InitialContactFormDetails extends Component {

    constructor(props) {
        super(props);
        this.items = this.props.config && this.props.config.contactForm ?
            this.props.config.contactForm.sort((i1, i2) => { return i1.selposition - i2.selposition }) : []

        this.components = this.items.map((item) => {
            const ref = React.createRef();
            if      (item.seltype === "checkBox")    { return { item, ref, component: <CheckBox    ref={ref} item={item} key={item.selposition} /> }}
            else if (item.seltype === "dropDown")    { return { item, ref, component: <DropDown    ref={ref} item={item} key={item.selposition} /> }}
            else if (item.seltype === "radioButton") { return { item, ref, component: <RadioButton ref={ref} item={item} key={item.selposition} /> }}
            else                   /* 'txtBox' */    { return { item, ref, component: <TextBox     ref={ref} item={item} key={item.selposition} /> }}
        })
    }

    render() {
        // Sort form items by selposition.
        return (
            <>
                <div className="s360-initial-form-details-container" style={this.containerStyle()}>
                    <div>{this.props.config.configDetails.contactFormIntroText}</div>
                    {this.components.map((component) => <>{component.component}</>)}
                </div>
                {!this.props.config.channels &&
                <div className={"s360-initial-form-start-button-container"}>
                   <button className="s360-initial-form-start-button"  onClick={this.submitForm} style={this.buttonStyle()}  >
                    <span class="s360-initial-form-start-button-span-text">{this.props.config.designDetails.contactFormButtonText}</span>  
                    </button>
                </div>
                }   

                {this.props.config.channels &&
                <div className={""} style={{"width":"94%","position":"relative","bottom":"0","alignItems":"center"}}>
                <button  className={"s360-initial-channel-cancel-btn"} style={{"width":"27%","marginRight":".3em","background":"#ff0000b0","color":"#fff","height":"40px","borderRadius":"8px","borderStyle":"none","marginLeft":"4.4em","fontSize":"14px","outline":"none"}} onClick={this.props.showLandingPage}>Cancel</button>
                    <button className="s360-initial-form-start-button"  onClick={this.submitForm} style={this.buttonStyleNew()} >
                    <span class="s360-initial-form-start-button-span-text">{this.props.config.designDetails.formButtonText}</span>  
                    </button>
                </div>
              }
              
            </>
        );

    }


   

    containerStyle = () => {
        return {
            backgroundColor: this.props.config.designDetails.pageBackgroundColor
        }
    }

    buttonStyle = () => {
        return {
            background: this.props.config.designDetails.formButtonBackground,
            color:      this.props.config.designDetails.formButtonColor,
            fontFamily:     this.props.config.designDetails.selectionButtonFont,
            fontSize:       this.props.config.designDetails.selectionButtonFontSize+"px",
        }
    }

    buttonStyleNew = () => {
        return {
            background: this.props.config.designDetails.formButtonBackground,
            color:      this.props.config.designDetails.formButtonColor,
            fontFamily:     this.props.config.designDetails.selectionButtonFont,
            fontSize:       this.props.config.designDetails.selectionButtonFontSize+"px",
            display:"inline-block",
            width:"35%"
        }
    }


    submitForm = () => {
        // TODO: Add validations for fields.
        let invalidOptions = this.components.filter(component => { return !component.ref.current.validate() });
        const isValid = invalidOptions.length === 0;
        if (isValid) {
            let params = {};
            let comps = this.components.reverse();
            
            comps.forEach(component => 
            {
               
                (component.item.seltype === 'checkBox' && component.ref.current.value().operations)?params[component.ref.current.props.item.label]=component.ref.current.value().operations.join(",")
                :params = { ...params, ...component.ref.current.value() }
                   
            });
        
            return apiService.createTicketWithFormData(params).then(result => {
                
                if (!result.data || result.data.error) {
                    this.setState({errorMessage: result.data.error || ''}, () => {
                        this.props.actions.showPopUpMessage(result.data.error || 'Something went worng. Please try again.');
                        
                    });
                } else {

                    this.props.actions.showPopUpMessage('Form submitted successfully');
                    this.props.showLandingPage();
                }
            }).catch(this.onAPIError)
           
        } else if (invalidOptions.length > 0) {
            let errorMessage = invalidOptions[0].ref.current.validationErrorMessage();
            this.props.actions.showPopUpMessage(errorMessage);
            invalidOptions[0].ref.current.focus = true;
        }
    }

}
export default InitialContactFormDetails;